import styled from "@emotion/styled";
import { Col, Image, Row, Tag } from "antd";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Props } from "../../../common/entity/props.entity";
import { NewsEntity } from "../entity/news.entity";

export const NewsItem = (props: Props) => {
	const [info, setInfo] = useState<NewsEntity>({});

	const navigate = useNavigate();

	useEffect(() => {
		setInfo(props.value);
	}, [props]);

	return (
		<Container>
			<Row>
				<Col xs={24} md={6} lg={6} className='left'>
					<Image src={info.image} preview={false} />
				</Col>
				<Col xs={24} md={18} lg={18} className='right'>
					<h3>{info.title}</h3>
					<div>
						{info.publishDate} | <Tag color={"blue"}>{info.newsTypeTitle}</Tag>
					</div>
					<div dangerouslySetInnerHTML={{ __html: info.newsDescription ?? "" }} />
					<div className='button' onClick={ () => {navigate(`/news/${info.id}`)}}>查看详情</div>
				</Col>
			</Row>
		</Container>
	);
};
const Container = styled.div`
	width: 100%;

	.left {
		.ant-image {
			border: 1px solid #ccc;
			padding: 0.5rem;
		}
	}

	.right {
		padding-left: .5rem;
		.button {
			padding: 1rem;
			color: #fff;
			background-color: #004885;
			width: 6rem;
			cursor: pointer;
		}

		.button:hover {
			background-color: #4085f4;
		}
	}
`;
